import PerfilEmpleadoService from 'src/modules/perfilEmpleado/perfilEmpleadoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PERFILEMPLEADO_VIEW';

const perfilEmpleadoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: perfilEmpleadoViewActions.FIND_STARTED,
      });

      const record = await PerfilEmpleadoService.find(id);

      dispatch({
        type: perfilEmpleadoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: perfilEmpleadoViewActions.FIND_ERROR,
      });

      getHistory().push('/perfil-empleado');
    }
  },
};

export default perfilEmpleadoViewActions;
